export const ENV = process.env.ENV || ENV;

export const BASE_ASSETS_URL =
  ENV === "development" ? "http://localhost:8080/src/assets/" : "https://assets.airtel.in/static-assets/b2b-ui-components-lib/";

export const B2B_BASE_ASSETS_URL = "https://assets.airtel.in/static-assets/cms/b2b/";

export const selfcareLoginPageBaseUrl = "https://www.airtel.in/business/thanksforbusiness/login/";

export const HEADER_ICON_URL = `${BASE_ASSETS_URL}images/airtel-business-logo.svg`;

export const HEADER_CATEGORY = {
  PRODUCTS: {
    ID: "PRODUCTS",
    SUB_CATERGORIES: {
      DATA: "DATA",
      MOBILITY: "MOBILITY",
      FIXEDLINE: "FIXEDLINE",
      IOT: "IOT",
      COLLABORATION: "COLLABORATION",
      CLOUD_SECURITY: "CLOUD_SECURITY",
    },
    DEFAULT_SUB_CATEGORY: "DATA",
  },
  SMART_BUNDLES: {
    ID: "SMART_BUNDLES",
    SUB_CATERGORIES: {
      DATA: "DATA",
      MOBILITY: "MOBILITY",
      FIXEDLINE: "FIXEDLINE",
    },
    DEFAULT_SUB_CATEGORY: "DATA",
  },
  SUPPORT: {
    ID: "SUPPORT",
    SUB_CATERGORIES: {
      FAQ: "FAQ",
      RAISE_ISSUE: "RAISE_ISSUE",
      FEEDBACK: "FEEDBACK",
      REPORT_BUG: "REPORT_BUG",
      CONTACT_US: "CONTACT_US",
    },
    DEFAULT_SUB_CATEGORY: "RAISE_ISSUE",
  },
};

export const ROLES = {
  ADMIN: "ADMIN",
  BILLING: "BILLING",
  ASSURANCE: "ASSURANCE",
  DELIVERY: "DELIVERY",
  GUEST: "GUEST",
};

export const DEVICE_TYPE = {
  WEB: "WEB",
  WAPP: "WAPP",
  APP: "APP",
};

export const CURRENCY_SYMBOLS = {
  INR: "₹",
  EUR: "€",
  GBP: "£",
  USD: "$",
  HKD: "HK$",
  MUR: "Rs",
  SGD: "S$",
  JPY: "¥",
  "Indian Rupees": "₹",
};

export const BREAKPOINTS = {
  desktopWeb: "lg",
  desktopWebBelow: "md",
  tabletWeb: "sm",
  mobileWeb: "xs",
};

export const CACHE_STATUS = {
  COMPLETED: "COMPLETED",
  IN_PROGRESS: "IN_PROGRESS",
  FAILED: "FAILED",
  INCOMPLETE: "IN_COMPLETE",
};

export const ALERT_NOTIFICATIONS = {
  TYPE: {
    default: "DEFAULT",
    success: "SUCCESS",
    info: "INFORMATION",
    warning: "WARNING",
    error: "ERROR",
    update: "UPDATE",
  },
};
export const VISIBILITY_THRESHOLD = 1;

export const DEFAULT_INTERSECTION_RATIO = 1;
